export default class CreditCardInfoModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.card_type = model.card_type ? model.card_type : '';
        this.name_on_card = model.name_on_card ? model.name_on_card : '';
        this.card_number = model.card_number ? model.card_number : '';
        this.card_expiry = model.card_expiry ? model.card_expiry : '';
        this.card_code = model.card_code ? model.card_code : '';
    }

}
